import { NetworkType } from 'abis/set/sets'
import Big from 'big.js'
import { unixTimestampToDate } from 'utils'
import { zeroAddress } from 'viem'
import { Product } from 'services/query-v2/products/index/product-info/model'
import { StateConfig } from 'components/charts/config'
import { ProductActionType } from 'pages/index-details/storage/interface'
import { SwitchElement } from '../../../../../pages/index-details/component/switch-sections/interface'
import { ApyData } from '../../apy/model'

export interface ProductStorage {
  apy: ApyData
  product: Product
  dailyStats: DailyStatistics
  timeWindow: StateConfig
  productPreviewSelection: SwitchElement
  dispatch: (action: ProductActionType) => void
  isError: boolean
}

export type RawDailyStatisticResponse = {
  basePrice: string
  basePriceETH: string
  date: number
  apy: string
  totalSupply: string
}

export type RawDailyStatisticsIndexResponse = {
  indexes: { dailyStats: RawDailyStatisticResponse[] }[]
}

export type PriceHistory = {
  basePrice: Big
  basePriceETH: Big
  totalSupply: Big
  date: Date
}

export type ApyHistory = {
  date: Date
  apy: number
}

export type DailyStatistics = {
  chainId: NetworkType
  productAddress: string
  currentPrice: Big
  priceHistory: PriceHistory[]
  isError?: boolean
}

export const defaultDailyStats: DailyStatistics = {
  chainId: NetworkType.Mainnet,
  productAddress: zeroAddress,
  currentPrice: Big(1),
  priceHistory: [
    {
      basePrice: Big(1),
      basePriceETH: Big(1),
      date: new Date(),
      totalSupply: Big(1),
    },
  ],
}

export const parseDailyStats = (
  response: RawDailyStatisticResponse[],
  productAddress: string,
  chainId: NetworkType,
): DailyStatistics => {
  const currentPrice = Big(response.length !== 0 ? response[0].basePrice : 0)

  const priceHistory: PriceHistory[] = []
  const apyHistory: ApyHistory[] = []

  response.forEach(({ date, basePrice, basePriceETH, apy, totalSupply }) => {
    priceHistory.push({
      date: unixTimestampToDate(date),
      basePrice: Big(basePrice),
      basePriceETH: Big(basePriceETH),
      totalSupply: Big(totalSupply),
    })
    apyHistory.push({ date: unixTimestampToDate(date), apy: Number(apy) })
  })

  return { chainId, productAddress, priceHistory, currentPrice }
}
